export const externalUrls = {
  pages: {
    helpInfo: {
      dataPrivacy: {
        title: 'helpInfo.dataPrivacy',
        url: '/privacy-policies'
      },
      imprint: {
        title: 'helpInfo.imprint',
        url: '/imprint'
      },
      support: {
        title: 'helpInfo.support',
        url: 'mailto:account-management@bsdigital.com'
      }
    }
  }
};

export default externalUrls;
